/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Box } from '@mui/material'
import { SEDIMENT_COLORS, SedimentLabel } from '../utils/hazardScenarioGrid.utils'

type HazardSedimentPillProps = {
  label: SedimentLabel
  'data-testid'?: string
}

export const HazardSedimentPill = ({ label, 'data-testid': testId }: HazardSedimentPillProps) => (
  <Box component="span" css={pillStyles(label)} data-testid={testId}>
    {label}
  </Box>
)

const pillStyles = (label: SedimentLabel) => {
  const { bg, color } = SEDIMENT_COLORS[label]
  return css`
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.7rem;
    font-weight: 700;
    background-color: ${bg};
    color: ${color};
  `
}
